// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"f5275eef8f9e53ac","931":"901a40df55581129"}[chunkId] + ".css";
};